import React, { useState } from "react";
import "../../styles/FranchisePageStyles/franchiseForm.css";
import {
  Form,
  Link,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import CommonHeaderComp from "../../utils/CommonHeaderComp";
import Select from "react-select";
import Footer from "../Footer";
import "../../styles/OurStoryPageStyles/ourStoryStyle.css";
import swal from "sweetalert";
import sotryImg1 from "../../assets/StoryPage/storyImg1.png";
import sotryImg2 from "../../assets/StoryPage/storyImg2.png";
import img1Toppings from "../../assets/StoryPage/img1Toppings.png";
import img2Toppings from "../../assets/StoryPage/Img2Toppings.png";
import Aos from "aos";
import axios from "axios";
import config from "../../config";
import Loader from "../../utils/Loader";

const FranchiseForm = () => {
  Aos.init({
    offset: 0,
    duration: 1000,
    once: true,
    easing: "ease-out-cubic",
    disable: "phone",
  });

  // const {first_name, last_name, phone_number} = useParams()
  const location = useLocation();
  const { data } = location.state || {};

  // alert("u r in form")
  // console.log("firstNmae", data?.first_name)
  // console.log("last_name", data?.last_name)
  // console.log("phone_number", data?.phone_number)

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [first_name, setFirstName] = useState(data?.first_name || "");
  const [last_name, setLastName] = useState(data?.last_name || "");
  const [phone, setPhone] = useState(data?.phone_number || "");
  const [email, setEmail] = useState("");
  const [state, setState] = useState("");
  const [pincode, setPinCode] = useState("");
  const [prefered_location, setPreferedLocation] = useState([]);
  const [prefered_locations_options, setPreferedLocationsOptions] = useState(
    []
  );
  const [price, setPrice] = useState("");
  const [address, setAddress] = useState("");
  const [purpose, setPurpose] = useState("");

  const [errors, setErrors] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    state: "",
    pincode: "",
    prefered_location: "",
    price: "",
    address: "",
    purpose: "",
  });

  // Form Validation
  const validateForm = () => {
    const newError = {};

    if (!first_name) {
      newError.first_name = "First Name is Required !";
    }

    // if (!last_name) {
    //   newError.last_name = "Last Name is Required !";
    // }

    if (!email) {
      newError.email = "Email is Required !";
    }

    if (!phone) {
      newError.phone = "Phone Number is Required !";
    } else if (phone.length > 10 || phone.length < 10) {
      newError.phone = "Please Enter Valid Phone Number.";
    } else if (!/^\d{10}$/.test(phone)) {
      newError.phone = "Please Enter a Valid 10-Digit Phone Number.";
    }

    if (!state) {
      newError.state = "Please Select State.";
    }

    if (prefered_location.length == 0) {
      newError.prefered_location = "Please Select Preferred Location";
    }

    if (!address) {
      newError.address = "Address is Required !";
    }

    if (!pincode) {
      newError.pincode = "Postal Code is Required !";
    }

    if (!price) {
      newError.price = "Price is Required !";
    }

    // if (!purpose) {
    //   newError.purpose = "Work Experience is Required !";
    // }

    setErrors(newError);
    return Object.keys(newError).length == 0;
  };

  const onFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setIsLoading(true);
      const output = prefered_location.map((option) => option.label).join(",");

      const formData = new FormData();
      formData.append("country", 1);
      formData.append("source", "website");
      formData.append("firstname", first_name);
      formData.append("lastname", last_name);
      formData.append("email", email);
      formData.append("phone", phone);
      formData.append("province", state);
      formData.append("pincode", pincode);
      formData.append("prefer_location", output);
      formData.append("price", price);
      formData.append("address", address);
      formData.append("purpose", purpose);

      try {
        const response = await axios({
          method: "post",
          url: `${config.apiUrl}/add_lead`,
          data: formData,
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }).then((res) => {
          swal({
            icon: "success",
            text: "Your Message Send Successfully !",
          }).then((data) => {
            setIsLoading(false);
            setFirstName("");
            setLastName("");
            setEmail("");
            setPhone("");
            setState("");
            setPinCode("");
            setPreferedLocation([]);
            setPrice("");
            setAddress("");
            setPurpose("");
          });
        });
      } catch (error) {
        setIsLoading(false);
        console.log("add franchise", error);
      }
    }
  };

  const Price_options = [
    { label: "Select Price", value: "Select Price" },
    { label: "$ 201K - $ 350K", value: "$ 201K - $ 350K" },
    { label: "$ 351K - $ 500K", value: "$ 351K - $ 500K" },
    { label: "Over $ 500K", value: "Over $ 500K" },
  ];

  const prefered_options = [
    { label: "Calgary", value: "Calgary" },
    { label: "Edmonton", value: "Edmonton" },
    { label: "Red Deer", value: "Red Deer" },
    { label: "Lethbridge", value: "Lethbridge" },
    { label: "Grande Prairie", value: "Grande Prairie" },
    { label: "Medicine Hat", value: "Medicine Hat" },
    { label: "Fort McMurray", value: "Fort McMurray" },
    { label: "Airdrie ", value: "Airdrie " },
    { label: "Spruce Grove", value: "Spruce Grove" },
    { label: "Leduc", value: "Leduc" },
  ];

  const getCities = async (e) => {
    setPreferedLocation([]);
    setState(e.target.value);
    setIsLoading(true);

    const formData = new FormData();
    formData.append("id", e.target.value);
    try {
      const response = await axios({
        method: "post",
        url: `${config.apiUrl}/location_city`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setPreferedLocationsOptions(
          res?.data?.city?.map((obj) => ({
            value: obj.id,
            label: obj.name,
          }))
        );
        setIsLoading(false);
      });
    } catch (error) {
      console.log("location city", error);
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="franchise_form_page">
        <CommonHeaderComp
          Heading="Franchise Form"
          height="60vh"
          pageName="Franchise Form"
          color="#ffdbe2"
        />
        {/* Image 1  */}
        <div className="position-absolute storyImg1" data-aos="fade-left">
          <img
            src={sotryImg1}
            className="img-fluid img1"
            alt="our story img 1"
            loading="lazy"
          ></img>
          <img
            src={img1Toppings}
            className="img-fluid img1Toping"
            alt="img1 Toppings"
            loading="lazy"
          ></img>
        </div>

        {/* Image 2  */}
        <div className="position-absolute storyImg2" data-aos="fade-rigth">
          <img
            src={sotryImg2}
            className="img-fluid img2"
            alt="our story img 2"
            loading="lazy"
          ></img>
          <img
            src={img2Toppings}
            className="img-fluid img2Toping"
            alt="img2 Toppings"
            loading="lazy"
          ></img>
        </div>

        <section className="container franchise_form_container">
          <div className="d-flex flex-column align-items-center justify-content-center franchise_form_heading my-5">
            <h1 className="hero_heading mb-4">Get Started</h1>
            <h4 className="mb-2">Start Your Franchising Journey Today</h4>
            <p className="mb-2">
              Interested in learning more about the franchise opportunities with
              Rollz Icecream®? Upon completion, a member of our franchise
              development team will contact you.
            </p>
          </div>

          <div className="franchise_form_box">
            <div className="franchise_form_head mb-3 ps-3">
              <h3 className="text-uppercase">
                Find out more about our franchise opportunities
              </h3>
              {/* <p>Please provide your contact informaiton.</p> */}
            </div>
            <form onSubmit={onFormSubmit}>
              {/* Please Information FOrm  */}
              <div className="column-gap-2 d-flex flex-column flex-md-row align-items-center justify-content-start franchise_form_feilds">
                <div className="col-12 col-md-6 d-flex flex-column align-items-start justify-content-start fname">
                  <label className="form_label mb-1 ms-1" htmlFor="fname">
                    First Name<span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control mb-2"
                    placeholder="Enter First Name"
                    value={first_name}
                    onChange={(e) => setFirstName(e.target.value)}
                  ></input>
                  {errors.first_name && (
                    <span className="error ms-1 px-2">
                      <i className="bi bi-exclamation-circle-fill me-1"></i>
                      <span>{errors.first_name}</span>
                    </span>
                  )}
                </div>

                <div className="col-12 col-md-6 d-flex flex-column align-items-start justify-content-start lname">
                  <label className="form_label mb-1 ms-1" htmlFor="fname">
                    Last Name
                  </label>
                  <input
                    type="text"
                    className="form-control mb-2"
                    placeholder="Enter Last Name"
                    value={last_name}
                    onChange={(e) => setLastName(e.target.value)}
                  ></input>
                  {errors.last_name && (
                    <span className="error ms-1 px-2">
                      <i className="bi bi-exclamation-circle-fill me-1"></i>
                      <span>{errors.last_name}</span>
                    </span>
                  )}
                </div>
              </div>

              {/* Emial and Phone  */}
              <div className="column-gap-2 d-flex flex-column flex-md-row align-items-center justify-content-start franchise_form_feilds">
                <div className="col-12 col-md-6 d-flex flex-column align-items-start justify-content-start fname">
                  <label className="form_label mb-1 ms-1" htmlFor="fname">
                    Email Address <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="email"
                    className="form-control mb-2"
                    placeholder="example@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  ></input>
                  {errors.email && (
                    <span className="error ms-1 px-2">
                      <i className="bi bi-exclamation-circle-fill me-1"></i>
                      <span>{errors.email}</span>
                    </span>
                  )}
                </div>

                <div className="col-12 col-md-6 d-flex flex-column align-items-start justify-content-start lname">
                  <label className="form_label mb-1 ms-1" htmlFor="fname">
                    Phone Number<span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control mb-2"
                    placeholder="Enter Phone Number"
                    // mask="(999) 999-9999"
                    value={phone}
                    maxLength={10}
                    // onKeyPress={(event) => {
                    //   if (!/[0-9.]/.test(event.key)) {
                    //     event.preventDefault();
                    //   }
                    // }}
                    onChange={(e) => setPhone(e.target.value)}
                  ></input>
                  {errors.phone && (
                    <span className="error ms-1 px-2">
                      <i className="bi bi-exclamation-circle-fill me-1"></i>
                      <span>{errors.phone}</span>
                    </span>
                  )}
                </div>
              </div>

              {/* State Sction  */}
              <div className="column-gap-2 d-flex flex-column flex-md-row align-items-center justify-content-start franchise_form_feilds">
                <div className="col-12 col-md-6 d-flex flex-column align-items-start justify-content-start fname">
                  <label className="form_label mb-1 ms-1" htmlFor="fname">
                    Select State <span className="text-danger"> *</span>
                  </label>

                  <select
                    className="form-control custom_select mb-2"
                    placeholder="Select State/Province/Territory"
                    value={state}
                    onChange={getCities}
                  >
                    <option>State/Province/Territory </option>
                    <option value="1">Alberta</option>
                    <option value="13">British Columbia</option>
                    <option value="3">Manitoba</option>
                    <option value="4">New Brunswick</option>
                    <option value="5">Newfoundland and Labrador</option>
                    <option value="6">Northwest Territories</option>
                    <option value="14">Nova Scotia</option>
                    <option value="7">Nunavut</option>
                    <option value="8">Ontario</option>
                    <option value="9">Prince Edward Island</option>
                    <option value="10">Quebec</option>
                    <option value="11">Saskatchewan</option>
                    <option value="12">Yukon</option>
                  </select>
                  {errors.state && (
                    <span className="error ms-1 px-2">
                      <i className="bi bi-exclamation-circle-fill me-1"></i>
                      <span>{errors.state}</span>
                    </span>
                  )}
                </div>

                <div className="col-12 col-md-6 d-flex flex-column align-items-start justify-content-start fname">
                  <label className="form_label mb-1 ms-1" htmlFor="fname">
                    Enter Postal Code <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control mb-2"
                    placeholder="Enter Postal Code"
                    value={pincode}
                    onChange={(e) => setPinCode(e.target.value)}
                  ></input>
                  {errors.pincode && (
                    <span className="error ms-1 px-2">
                      <i className="bi bi-exclamation-circle-fill me-1"></i>
                      <span>{errors.pincode}</span>
                    </span>
                  )}
                </div>
              </div>

              {/* Prefered Location  */}
              <div className="column-gap-2 d-flex flex-column flex-md-row align-items-center justify-content-start franchise_form_feilds">
                <div className="col-12 col-md-12 d-flex flex-column align-items-start justify-content-start fname">
                  <label className="form_label mb-1 ms-1" htmlFor="fname">
                    Select Preferred Location{" "}
                    <span className="text-danger"> *</span>
                  </label>

                  <Select
                    options={prefered_locations_options}
                    placeholder="Preferred Locations"
                    className="custom_select mb-2 select_preferred"
                    value={prefered_location}
                    onChange={(e) => {
                      if (e?.slice(-1)[0]?.label?.toLowerCase() == "edmonton") {
                        swal({
                          title: "We Appreciate Your Interest!",
                          text: "Unfortunately, franchise is not Available in Edmonton but try out your Luck",
                          icon: "warning",
                          confirmButtonText: "Try Your Luck",
                          buttons: true,
                        }).then((ifyes) => {
                          if (ifyes) {
                            setPreferedLocation(e);
                          }
                        });
                      } else {
                        setPreferedLocation(e);
                      }
                    }}
                    closeMenuOnSelect={false}
                    isMulti
                  />
                  {errors.prefered_location && (
                    <span className="error ms-1 px-2">
                      <i className="bi bi-exclamation-circle-fill me-1"></i>
                      {errors.prefered_location}
                    </span>
                  )}
                </div>
              </div>

              {/* Price  */}
              <div className="column-gap-2 d-flex flex-column flex-md-row align-items-center justify-content-start franchise_form_feilds">
                <div className="col-12 col-md-6 d-flex flex-column align-items-start justify-content-start fname">
                  <label className="form_label mb-1 ms-1" htmlFor="fname">
                    Select Price <span className="text-danger"> *</span>
                  </label>

                  <select
                    className="form-control custom_select mb-2"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                  >
                    <option value="">Select Price *</option>
                    <option value="$100K - $200K">$100K – $200K</option>
                    <option value="$201K - $350K">$201K – $350K</option>
                    <option value="$351K - $500K">$351K – $500K</option>
                    <option value="Over $500K">Over $500K</option>
                  </select>
                  {errors.price && (
                    <span className="error ms-1 px-2">
                      <i className="bi bi-exclamation-circle-fill me-1"></i>
                      {errors.price}
                    </span>
                  )}
                </div>
              </div>

              {/* Enter Address */}
              <div className="column-gap-2 d-flex flex-column flex-md-row align-items-center justify-content-start franchise_form_feilds">
                <div className="col-12 col-md-12 d-flex flex-column align-items-start justify-content-start fname">
                  <label className="form_label mb-1 ms-1" htmlFor="fname">
                    Enter Address <span className="text-danger"> *</span>
                  </label>

                  <input
                    type="text"
                    className="form-control mb-2"
                    placeholder="Enter Address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  ></input>
                  {errors.address && (
                    <span className="error ms-1 px-2">
                      <i class="bi bi-exclamation-circle-fill me-1"></i>
                      <span>{errors.address}</span>
                    </span>
                  )}
                </div>
              </div>

              {/* Experience  */}
              <div className="column-gap-2 d-flex flex-column flex-md-row align-items-center justify-content-start franchise_form_feilds">
                <div className="col-12 d-flex flex-column align-items-start justify-content-start fname">
                  <label className="form_label mb-1 ms-1" htmlFor="fname">
                    Work Experience
                  </label>

                  <textarea
                    name="Work Experience"
                    id=""
                    className="form-control experience mb-2"
                    placeholder="A summary of your professional work experience."
                    value={purpose}
                    onChange={(e) => setPurpose(e.target.value)}
                  ></textarea>
                  {errors.purpose && (
                    <span className="error ms-1 px-2">
                      <i class="bi bi-exclamation-circle-fill me-1"></i>
                      <span>{errors.purpose}</span>
                    </span>
                  )}
                </div>
              </div>

              {/* Submit Button  */}
              <div className="order-online mt-5">
                <button className="blue-btn hero-anchor" type="submit">
                  <div className="order-online-trans-1"></div>
                  <div className="order-online-trans-2"></div>
                  Submit
                </button>
              </div>
            </form>
          </div>
        </section>

        {/* <Footer color="#ffdbe2" /> */}
      </div>
    </>
  );
};

export default FranchiseForm;
